const dataHandle = {
  /**
   * 格式化时间
   * @param {Number}   times       毫秒数
   * @param {Bool}     isHasSec    是否要返回秒（true==>2017-12-12 00:00:00）
   */
  formatDate: (times, isHasSec) => {
    if (typeof times == 'string') {
      times = times.replace(/-/g, "/");
    }
    let today = new Date().toLocaleDateString(),
      todayTimes = new Date(`${today} 00:00:00`).getTime(),
      yesterdayTimes = todayTimes - 24 * 60 * 60 * 1000;
    let msgTime = new Date(times);
    let year = msgTime.getFullYear(),
      month = msgTime.getMonth() + 1,
      day = msgTime.getDate(),
      hour = msgTime.getHours() < 10 ? `0${msgTime.getHours()}` : msgTime.getHours(),
      minu = msgTime.getMinutes() < 10 ? `0${msgTime.getMinutes()}` : msgTime.getMinutes(),
      sec = msgTime.getSeconds() < 10 ? `0${msgTime.getSeconds()}` : msgTime.getSeconds();
    if (isHasSec) {
      return `${year}-${month}-${day} ${hour}:${minu}:${sec}`;
    }
    if (times >= yesterdayTimes && times < todayTimes) {
      return `昨天 ${hour}:${minu}`;
    } else if (times > todayTimes) {
      return `${hour}:${minu}`;
    }
    return `${month}月${day}日 ${hour}:${minu}`;
  },
  getUid: () => {
    return new Date().getTime() + '' + Math.floor(Math.random() * 899 + 100);
  },
  getDateTimes: (date) => {
    return new Date(date).getTime();
  },
  // 检测是否有链接或电话并带上a标签 <a ([^>]*?)>)(.*?)(</a>
  testHref: (content) => {
    let reg = /((http:\/\/|https:\/\/))((\w|=|\?|\.|\/|&|-)+)/g;
    let tel = /([0-9]{3,4}\-[0-9]{3,4}\-[0-9]{3,4})/g;
    let data = content.split(/(<a [^>]*?>.*?<\/a>)/g);
    for (let key in data) {
      if (data[key].indexOf('</a>') == -1) {
        let item = data[key].replace(tel, "<a href='tel:$1'>$1</a>").replace(/\n/g, "<br />");
        if (reg.test(item)) {
          data[key] = item.replace(reg, "<a href='$1$3' target='_blank'>$1$3</a>")
        }
      } else if (data[key].indexOf('<a href' > -1) && reg.test(data[key])) {
        data[key] = data[key].replace('<a', "<a target='_blank'");
      }
    }
    let res = data.join('');
    return res;
  },
  /**
   * 将内容中的标签转义
   *
   * @param {any} content  需要转义的内容
   * @returns
   */
  getHtml: (content) => {
    let result = content;
    if (content && content.indexOf('&lt;' > -1)) {
      result = content.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    }
    let emojiArray = result.match(/:\).*?:\)/g);
    if (emojiArray && emojiArray.length) {
      for (let i = 0; i < emojiArray.length; i++) {
        let emojiText = emojiArray[i].substring(2, emojiArray[i].length - 2);
        result = result.replace(emojiArray[i], `<span title=":${emojiText}:" class="emoji-item sprite-${emojiText}"></span>`);
      }
    }
    return result;
  },
  /**
   * 设置cookie
   * @param {String} name  要设置的cookie的key
   * @param {String} val   要设置的cookie的value(7天后过期)
   */
  setCookie: (name,val) => {
    let passTime = new Date();
    passTime.setTime(passTime.getTime() + 24*60*60*1000*7);
    document.cookie = process.env.DEPLOY_ENV=='prod'?`${name}=${val};domain=.wld.net;path=/;expires=${passTime.toGMTString()}`:`${name}=${val};path=/;expires=${passTime.toGMTString()}`;
  },
  /**
   * 获取cookie
   * @param {String} name  要获取的cookie的key
   */
  getCookie: (name) => {
    let cookieString = document.cookie;
    if (!cookieString.length) return;
    let hasName = cookieString.indexOf(name + '=');  // 是否存在该key
    if (hasName > -1) {
      let result = {};
      let cookieArray = cookieString.split('; ');
      for (let item of cookieArray) {
        let arr = item.split('=');
        result[arr[0]] = arr[1];
      }
      return result[name];
    }
  },
}
export {
  dataHandle
}



// WEBPACK FOOTER //
// ./src/services/data-handle.js